<template>
  <div class="c-breadcrumb">
    <span v-for="item in list">
      <a :href="item[1]" class="c-link c-link--breadcrumb">{{item[0]}}</a>
      <svg width="6" height="11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1l4 4.5L1 10" stroke="#444" /></svg>
    </span>
    {{lastStep[0] | titleCase}}
  </div>
</template>

<script>
  export default {
    name: 'breadcrumb',
    props: {
      steps: Array
    },
    computed: {
      lastStep() {
        return this.steps[this.steps.length - 1];
      },
      list() {
        return this.steps.slice(0, this.steps.length - 1)
      },
    }
  };
</script>
